import { useApplicationsServiceApplicationsApplicationsLogList } from '@organization/api/queries'
import { ApplicationLog } from '@organization/api/requests'
import { TitleSection } from '@shared/components'
import { usePaginationConfig, useQueryUpdate, useSorting } from '@shared/hooks'
import { Flex } from 'antd'
import { useTranslation } from 'react-i18next'

import {
  LogApplicationsFilters,
  LogApplicationsHeader,
  LogApplicationsTable
} from '../components'

export const LogsApplicationsPage = () => {
  const { t } = useTranslation()
  const { params, updateQuery } = useQueryUpdate()

  const { triggerSort, getSortedTableColumns } = useSorting<ApplicationLog>()

  const { data, isLoading } =
    useApplicationsServiceApplicationsApplicationsLogList(params)

  return (
    <>
      <TitleSection
        title={t('menu.logs_applications')}
        count={data?.count}
        isLoading={isLoading}
      >
        <LogApplicationsHeader />
      </TitleSection>

      <Flex vertical gap={16}>
        <LogApplicationsFilters />

        <LogApplicationsTable
          data={data?.results}
          loading={isLoading}
          triggerSort={triggerSort}
          getSortedTableColumns={getSortedTableColumns}
          pagination={{
            ...usePaginationConfig(data),
            onChange: (page: number, pageSize: number) =>
              updateQuery({
                ...params,
                page: page.toString(),
                pageSize: pageSize.toString()
              })
          }}
        />
      </Flex>
    </>
  )
}
